import { EmeraldButton } from "@emerald-react/button";
import { EmeraldInputV2 } from "@emerald-react/input-v2";
import { EmeraldButtonSize, EmeraldButtonVariant } from "@emerald/nxcore";
import type { LeaseCompFieldRule } from "@survey-types/survey.core.types";
import { useState } from "react";

interface EditLeaseCompFieldLabelProps {
  rule: LeaseCompFieldRule;
  onClose: () => void;
  onSave: (newLabel: string) => void;
}

const EditLeaseCompFieldLabel = ({
  rule,
  onClose,
  onSave,
}: EditLeaseCompFieldLabelProps) => {
  const [fieldLabel, setFieldLabel] = useState(rule.displayName);
  const [errorText, setErrorText] = useState("");

  const validateLabel = (): boolean => {
    if (fieldLabel.trim() === "") {
      setErrorText("This field is required.");
      return false;
    }

    setErrorText("");
    return true;
  };

  const handleSave = () => {
    if (validateLabel()) {
      onSave(fieldLabel.trim());
      onClose();
    }
  };

  return (
    <div className="overflow-hidden transition-all duration-300">
      <div className="bg-secondary-lightest p-4 rounded-lg">
        <EmeraldInputV2
          type="text"
          label="Field Label"
          value={fieldLabel}
          size="small"
          className={"without-label"}
          isValid={errorText === ""}
          errorText={errorText}
          placeholder="Field Label"
          onChange={(e) => setFieldLabel(e.target.value)}
        />
        <div className="flex mt-4 gap-4 justify-end">
          <EmeraldButton
            label="Cancel"
            type={EmeraldButtonVariant.TextButton}
            size={EmeraldButtonSize.Medium}
            nativeProps={{
              title: "Cancel",
              type: "button",
              "aria-labelledby": "cancel-field-label",
              "aria-label": "Cancel Field Label Edit",
            }}
            onClick={onClose}
          />
          <EmeraldButton
            label="Save"
            type={EmeraldButtonVariant.Primary}
            size={EmeraldButtonSize.Medium}
            nativeProps={{
              title: "Save",
              type: "button",
              "aria-labelledby": "save-field-label",
              "aria-label": "Save Field Label Edit",
            }}
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
};

export default EditLeaseCompFieldLabel;
